import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const WarningIcon = ({size = SIZE.STANDARD, color = '#000', onClick, updated}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '14';
			case SIZE.STANDARD:
				return '16';
			default:
				return '14';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '14';
			case SIZE.STANDARD:
				return '16';
			default:
				return '16';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			{updated ? (
				<svg width={getWidth(size)} height={getHeight(size)} viewBox="0 0 16 16" fill="none">
					<path
						d="M7.39331 5.44109C7.39331 5.10542 7.66542 4.83331 8.00109 4.83331C8.33676 4.83331 8.60887 5.10542 8.60887 5.44109V9.08776C8.60887 9.42343 8.33676 9.69554 8.00109 9.69554C7.66542 9.69554 7.39331 9.42343 7.39331 9.08776V5.44109Z"
						fill={color}
					/>
					<path
						d="M8.0278 12.2799H8.01225C7.55734 12.2785 7.18457 11.9182 7.1673 11.4633C7.15922 11.2433 7.23984 11.0294 7.39102 10.8695C7.54221 10.7096 7.75126 10.6173 7.97117 10.6133H7.98672C8.44155 10.6138 8.8149 10.9735 8.83278 11.4283C8.84147 11.6487 8.76096 11.8634 8.60946 12.0237C8.45795 12.184 8.24825 12.2764 8.0278 12.2799Z"
						fill={color}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M6.37596 2.02282C7.06226 0.71261 8.93771 0.71261 9.62401 2.02282L14.7538 11.816C15.3932 13.0367 14.5077 14.5 13.1297 14.5H2.87024C1.49222 14.5 0.606807 13.0367 1.24622 11.816L6.37596 2.02282ZM8.73818 2.48682C8.42622 1.89127 7.57375 1.89127 7.26179 2.48682L2.13205 12.28C1.84141 12.8348 2.24387 13.5 2.87024 13.5H13.1297C13.7561 13.5 14.1586 12.8348 13.8679 12.28L8.73818 2.48682Z"
						fill={color}
					/>
				</svg>
			) : (
				<svg xmlns="http://www.w3.org/2000/svg" width={getWidth(size)} height={getHeight(size)} viewBox="0 0 20 20">
					<path
						fill={color}
						fillRule="evenodd"
						d="M8.566.235a.8.8 0 0 0-1.131 0l-7.2 7.2a.8.8 0 0 0 0 1.13l7.2 7.2a.798.798 0 0 0 1.13 0l7.2-7.2a.8.8 0 0 0 0-1.13l-7.2-7.2z"
					></path>
					<path fill="#FFF" fillRule="nonzero" d="M8 12.2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
					<path fill="#FFF" fillRule="nonzero" d="M7.2 9.188h1.6L9.6 4.8H6.4z" />
				</svg>
			)}
		</StyledSpan>
	);
};

WarningIcon.SIZE = SIZE;
WarningIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	updated: PropTypes.bool,
};

export const StyledSpan = Styled.span`
	display: flex;
	align-self: center;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
